/**
 * Geometría del isotipo de La Tablapp: la flecha que avanza.
 *
 * Es **solo el trazado**, sin color: cada consumidor decide con qué tinta pinta las
 * masas blancas, porque no es la misma en un favicon (fondo propio), en el loader de
 * boot (isla de tema) o en un footer.
 *
 * Vive acá y no en la zona de experimentos porque lo consume producto: el favicon, el
 * `BrandMark` de las pantallas de error, el sidebar de la consola y el loader de liga.
 */
export const ISOTIPO = {
  viewBox: "0 0 100 62",
  /** Las dos masas de tinta: el ala de arriba y el cuerpo de abajo. */
  tinta: [
    "M56.6 0 L84.4 27.8 L86.9 27.6 L86.9 6.6 L100 8 L98.6 51.4 L54.1 50 L54.1 39.6 L76.4 38.1 L47.4 10.5 Z",
    "M0 11.9 L42 11.9 L43.4 22.4 L23.6 24.9 L51.2 51.5 L50 55.3 L40.8 61.9 L14.3 34.2 L13.1 53.9 L1.4 55.3 L0 11.9 Z",
  ],
  /** La masa de marca. Mantiene su verde aunque la liga tenga otro acento. */
  verde: "M46.1 10.7 L74.9 36.9 L52.7 38.1 L52.6 52.7 L23.7 24.9 L45.9 23.7 Z",
} as const;

/**
 * Paleta literal de la marca.
 *
 * Va literal y no como token a propósito: estas piezas se pintan **fuera del árbol con
 * tema** —`global-error` monta su propio `<html>`, el favicon no es React, el loader de
 * boot corre antes de que exista el tema— así que no hay CSS vars que resolver.
 */
export const MARCA = {
  fondo: "#0A1821",
  tinta: "#F0FDF4",
  verde: "#84CC16",
  /**
   * El mismo verde calibrado para papel: es el `--ld-accent` del tema claro. El lima de
   * arriba se lee bien sobre la piel oscura y se apaga hasta desaparecer sobre la clara
   * —una barra de avance en lima sobre `#F2F5F3` no se ve—, así que lo que NO cambia
   * entre modos es de qué color es la marca, no su valor hexadecimal. Ojo: esto vale
   * para lo que la marca **pinta como acento** (una barra, un relleno), no para el
   * isotipo: un logotipo no cambia de color entre modos (WCAG 1.4.3 lo exime).
   */
  verdeClaro: "#3F6212",
} as const;

/**
 * El isotipo centrado en un lienzo cuadrado, para cuando hace falta un ícono con la
 * proporción de un avatar/favicon en vez de la apaisada del isotipo suelto.
 *
 * Escala: 46/100 del ancho → 28.5 de alto; centrado = translate(9, 17.75).
 */
export const EN_CUADRADO = { escala: 0.46, x: 9, y: 17.75, lado: 64 } as const;
